var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowChartLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.3L4.5 4.8L7.5 8.3L10.5 4.3L12 2.3L13 1M13 1L13.5 2.8M13 1L11 1.3",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 14.7998C1.22386 14.7998 1 14.6527 1 14.4712V10.5284C1 10.3469 1.22386 10.1998 1.5 10.1998C1.77614 10.1998 2 10.3469 2 10.5284V14.4712C2 14.6527 1.77614 14.7998 1.5 14.7998Z",
    fill: "#7583F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.7998C4.22386 14.7998 4 14.5759 4 14.2998V8.2998C4 8.02366 4.22386 7.7998 4.5 7.7998C4.77614 7.7998 5 8.02366 5 8.2998V14.2998C5 14.5759 4.77614 14.7998 4.5 14.7998Z",
    fill: "#7583F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.7998C7.22386 14.7998 7 14.6559 7 14.4784V10.6212C7 10.4437 7.22386 10.2998 7.5 10.2998C7.77614 10.2998 8 10.4437 8 10.6212V14.4784C8 14.6559 7.77614 14.7998 7.5 14.7998Z",
    fill: "#7583F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 14.7998C10.2239 14.7998 10 14.5759 10 14.2998V8.2998C10 8.02366 10.2239 7.7998 10.5 7.7998C10.7761 7.7998 11 8.02366 11 8.2998V14.2998C11 14.5759 10.7761 14.7998 10.5 14.7998Z",
    fill: "#7583F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 14.7998C13.2239 14.7998 13 14.48 13 14.0855V5.51409C13 5.1196 13.2239 4.7998 13.5 4.7998C13.7761 4.7998 14 5.1196 14 5.51409V14.0855C14 14.48 13.7761 14.7998 13.5 14.7998Z",
    fill: "#7583F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowChartLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/arrowChartLightBlueNoBgOutline.583bcaedca477f86f581c1953908bf65.svg";
export { ForwardRef as ReactComponent };